import { isObject } from './isObject.js';

export const toSafeObjectOrNull = (value) => {
  if (!isObject(value)) {
    return null;
  }

  return value;
};
